/* Client-side pagination for the Blog page.

   /blog/ is a Ghost page, not a collection, so it has no `posts` context and
   no `pagination` object — the template's paginated branch never runs and
   Ghost emits no link[rel=next] for pagination.js to follow. The static
   fallback therefore fetches every post and pages through them here.

   Without JS every post stays visible and the nav stays hidden, so the page
   degrades to a full archive rather than to a truncated one. */
(function () {
    const feed = document.querySelector('.iki-blog-feed[data-paginate]');
    const nav = document.querySelector('[data-blog-pagination]');
    if (!feed || !nav) return;

    const posts = Array.from(feed.children);
    const perPage = parseInt(feed.dataset.paginate, 10) || 6;

    // Everything fits on one page: leave the posts visible, leave the nav hidden.
    if (posts.length <= perPage) return;

    const prev = nav.querySelector('[data-page-prev]');
    const next = nav.querySelector('[data-page-next]');
    const status = nav.querySelector('[data-page-status]');
    const pageCount = Math.ceil(posts.length / perPage);
    let page = 0;

    function render(focusFeed) {
        posts.forEach(function (post, i) {
            post.hidden = Math.floor(i / perPage) !== page;
        });

        prev.disabled = page === 0;
        next.disabled = page === pageCount - 1;
        status.textContent = 'Page ' + (page + 1) + ' of ' + pageCount;

        if (focusFeed) {
            feed.scrollIntoView({block: 'start', behavior: 'smooth'});
        }
    }

    function go(delta) {
        const target = page + delta;
        if (target < 0 || target > pageCount - 1) return;
        page = target;
        render(true);
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    nav.hidden = false;
    render(false);
})();
